import { useQuery } from '@apollo/client/react';

import { Employer, Organisation } from '@pflegia/data-access';

import { GET_ORGANISATION_PUBLIC_CONTACT_DETAILS } from '../../graphql/get-organisation-public-contact-details';

const useGetCemContactDetails = (
  employer: Pick<Employer, 'organisationId'> & { organisation?: Pick<Organisation, 'id' | 'publicEmail' | 'publicPhoneNumber'> | null },
  anonymous = false,
) => {
  const organisationId = employer?.organisation?.id ?? employer?.organisationId;
  const { publicPhoneNumber, publicEmail } = employer?.organisation ?? {};
  const { loading, data } = useQuery(GET_ORGANISATION_PUBLIC_CONTACT_DETAILS, {
    skip: Boolean(!organisationId || publicPhoneNumber || publicEmail || anonymous),
    variables: { organisationId },
  });

  return { loading, cemPlusContactInfo: data?.data ?? { publicPhoneNumber, publicEmail } };
};

export default useGetCemContactDetails;
